

export const dropboxConfig = {
    DROPBOX_CLIENTID : "imbani16",
    DROPBOX_SECRET   : "t9zg36csyspw3rq",
    DROPBOX_TOKEN    : "_CMzjFm2Q9AAAAAAAAAALaugoSv1FZgE6IkdtkV3jbV35s_nOagnG4MPKz0Qhk6H",
    server:"https://cloudcalls.easipath.com",
    serverBackend:"backend-pmis/api",
}

export const dropboxConfig2 = {
    DROPBOX_CLIENTID : "3ule8jkyytjyn8r",
    DROPBOX_SECRET   : "wb9u8llx79scam0",
    DROPBOX_REFRESH_TOKEN    : "jSFM6VeHS2oAAAAAAAAAAb8CINpsYqcD-p53kkDLEcWiLw6_1R-z_nH5m6QOSz__",
    server:"https://cloudcalls.easipath.com",
    serverBackend:"backend-pmis/api",
}
